import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2a9749a9"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2a9749a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_304b4a1ebea3bd82ec282759e0696211/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports